/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Antsy_Lost_Buzzard_NudgeInputs */

const fr_antsy_lost_buzzard_nudge = /** @type {(inputs: Antsy_Lost_Buzzard_NudgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les roles`)
};

/**

* @param {Antsy_Lost_Buzzard_NudgeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const antsy_lost_buzzard_nudge = /** @type {((inputs?: Antsy_Lost_Buzzard_NudgeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Antsy_Lost_Buzzard_NudgeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_antsy_lost_buzzard_nudge(inputs)
});